import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface IProps {
  name?: string;
  isActionModalOpened: boolean;
  handleConfirmDeletion: () => void;
  handleCloseActionModal: () => void;
}

const ConfirmationModal = ({
  name,
  handleCloseActionModal,
  handleConfirmDeletion,
  isActionModalOpened,
}: IProps) => {
  const { t } = useTranslation();
  return (
    <Modal show={isActionModalOpened} onHide={handleCloseActionModal} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t('general.areYouSure')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h6
          className={'text-center'}
          dangerouslySetInnerHTML={{
            __html: t('general.areYouSureDesc', { name }),
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseActionModal}>
          {t('button.close')}
        </Button>
        <Button variant="danger" onClick={handleConfirmDeletion}>
          {t('button.delete', { name })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
